import styled from 'styled-components';

const Value = styled.div`
    color: ${props => props.theme.callouts.colors.value};
    font-size: 28px;
    letter-spacing: 1px;
    line-height: 32px;
`;

export default Value;



// WEBPACK FOOTER //
// ./src/components/atoms/callout/Value.js